export default {
  oops: 'Oups!',
  validOrigin: 'Veuillez sélectionner un lieu de départ valide',
  validDestination: 'Veuillez sélectionner une destination valide',
  validOutboundDate: 'Veuillez sélectionner une date de départ valide',
  validReturnDate: 'Veuillez sélectionner une date de retour valide',
  validChildAges: "Merci de spécifier l'âge des enfants.",
  oneChild: '1 seul enfant (âgé de 0 à 2 ans) par adulte est autorisé.',
}
